import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { getSessionItem } from '../../shared/utils';

@Component({
  selector: 'app-redirect',
  imports: [],
  templateUrl: './redirect.component.html',
  styleUrl: './redirect.component.css'
})
export class RedirectComponent {

  constructor(private router: Router) { }

  ngOnInit() {
    // check if user is logged in and redirect
    const user = getSessionItem('accessToken');
    if (user) {
      this.router.navigate(['/cims']);
    }

    this.router.navigate(['/signin']);
  }
}
